import 'tippy.js/dist/tippy.css';

import * as S from './styles';

import { MapPinned, Trophy } from 'lucide-react';
import React, { useCallback } from 'react';

import { DivProps } from '../../../../../typings';
import Tippy from '@tippyjs/react';
import { TourneyEncoded } from 'modules/tournaments/domain/interfaces/tourney-encoded';
import { TourneyStatus } from 'modules/tournaments/domain/enums/tourney-status';
import UDText from 'ud-ui/components/text';
import classNames from 'classnames';
import { Championship } from 'modules/tournaments/domain/interfaces/responce-dto';

type Props = {
  // tourney: TourneyEncoded;
  tourney: Championship;
  containerProps?: Omit<DivProps, 'children' | 'onClick'>;
  onClickCard: (id: TourneyEncoded['id']) => any;
};

const statusIndicatorMessage = {
  [TourneyStatus.OPEN]: 'Прием заявок открыт',
  [TourneyStatus.CLOSE]: 'Прием заявок закрыт',
};

const TourneyComponentsTourneyCard = (props: Props) => {
  const start = props.tourney.startDate ? new Date(props.tourney.startDate).toLocaleDateString('ru') : null;
  const end = props.tourney.endDate ? new Date(props.tourney.endDate).toLocaleDateString('ru') : null;

  const onClickCard = useCallback(() => {
    props.onClickCard(props.tourney.id);
  }, [props]);

  return (
    <S.CardContainer
      {...props.containerProps}
      className={classNames('d-flex flex-column py-4 pl-3 pr-4', props.containerProps?.className)}
      onClick={onClickCard}
    >
      <div className="d-flex align-items-center mb-5 flex-row">
        <Trophy size={16} className="mr-1" />
        <UDText type="caption-2" className="color-SurfaceRomanSilver30">
          Турнир
        </UDText>
        <MapPinned size={16} className="color-SurfaceRomanSilver30 ml-auto mr-1" />
        <UDText type="caption-2" className="color-SurfaceRomanSilver30">
          {props.tourney.address?.city}
        </UDText>
      </div>
      <S.StyledTournamentName type="subhead" className="bold">
        {props.tourney.name}
      </S.StyledTournamentName>
      <div className="d-flex align-items-center justify-content-between mt-auto flex-row">
        <UDText type="subhead" className="date color-SurfaceRichBlack60">
          {start} — {end || <span className="color-SurfaceRomanSilver30">открытая дата</span>}
        </UDText>
        <Tippy content={statusIndicatorMessage[props.tourney?.status ?? TourneyStatus.CLOSE]} placement="right" interactive={false}>
          <S.StatusIndicator data-status={props.tourney?.status} />
        </Tippy>
      </div>
    </S.CardContainer>
  );
};

export default TourneyComponentsTourneyCard;
